'use client'
import React, { useEffect, useState } from 'react'
import Head from 'next/head'
import PageBanner from '../PageBanner';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import service from '../../../../config';
export interface FormValues {
  name: string;
  email: string;
  subject: string;
  description: string;
}
const Contact: React.FC = () => {
  const [formData, setFormData] = useState<FormValues>({
    name: '',
    email: '',
    subject: '',
    description: ''
  });

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [nameError, setNameError] = useState<string | null>(null);
  const [emailError, setEmailError] = useState<string | null>(null);
  const [subjectError, setSubjectError] = useState<string | null>(null);
  const [descriptionError, setDescriptionError] = useState<string | null>(null);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Validate each field independently
    // const trimmedValue = value.trim();
    // Find the index of the first non-space character
const indexOfFirstNonSpace = value.search(/\S/);

// Trim the value starting from the first non-space character
const trimmedValue = (indexOfFirstNonSpace !== -1) ? value.substring(indexOfFirstNonSpace) : '';

    let isValid = value.length > 0 ? trimmedValue.length > 0 : true;
    // let isValid=false;
    if (name ==  "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      isValid = emailRegex.test(trimmedValue);
    } else {
      isValid = trimmedValue.length > 0;
    }
    // Perform validation based on the field name
    switch (name) {
      case 'name':
        setNameError(isValid ? null : 'Please Enter Your Name');
        break;
      case 'email':
        setEmailError(isValid ? null : 'Please Enter Valid Email');
        break;
      case 'subject':
        setSubjectError(isValid ? null : 'Please Enter Your Subject');
        break;
      case 'description':
        setDescriptionError(isValid ? null : 'Please Enter Your Description');
        break;
      default:
        break;
    }

    // Update form data
    setFormData({ ...formData, [name]: trimmedValue });
  };

  const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // Check if any of the required fields are empty
    if (
      formData.name.trim() === '' ||
      formData.email.trim() === '' ||
      formData.subject.trim() === '' ||
      formData.description.trim() === ''
    ) {
      toast.error('Please fill all required fields',{ toastId: 'error'});
      return;
    }

    // Check if any errors exist
    if (nameError === null && emailError === null && subjectError === null && descriptionError === null) {
      handleSubmit(e);
    } else {
      toast.error('Please fill all required fields correctly',{ toastId: 'error'});
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(service?.API_URL+'/api/mail/mail-confirmation', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        const data = await response.json();
        setSuccess(data.message);
        //clear the input field when the data is correct
        setFormData({
          name: '',
          email: '',
          subject: '',
          description: ''
        });
        setError(null);
        toast.success("Submitted Successfully", { toastId: 'uniqueSuccessId'});
      } else {
        const errorData = await response.json();
        setError(errorData.error);
        setSuccess(null);
        toast.error("Failed to submit form", { toastId: 'error' });
      }
    } catch (error) {
      setError('Failed to submit form');
      setSuccess(null);
      toast.error("Failed to submit form", { toastId: 'error' });
    }
  };
  return (
    <>
      <Head>
        <title>Contact Us - Pyther Innovation</title>
        {/* <link rel="canonical" href={`${process.env.NEXT_PUBLIC_SERVER_URL}/contact-us`} /> */}
        <meta httpEquiv="Content-Security-Policy" content="default-src 'self' http://localhost:8008 https://api.pyther.com/" />
      </Head>
      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <PageBanner pageName={'Contact Us'} pageTitle={'Get in touch and Go Digital'} />

      {/* contact section*/}
      <section className="mil-contact mil-p-20-0">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-lg-7 col-xl-7 col-md-12">
              <form onSubmit={handleFormSubmit}>
                <h2 className="mil-accent mil-h2" style={{marginTop:"2rem", marginBottom:"1rem"}}>Contact Us</h2>
                <div className="row">
                  <div className="col-lg-6 service-img">
                    <div className="mil-input-frame mil-dark-input mil-tb">
                      <label className="mil-h6 mil-dark">
                        <span> Full Name</span>
                      </label>
                      <input type="text"
                        placeholder="Enter Your Name"
                        name="name"
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        value={formData.name}
                      />
                      {nameError && <span className="text-danger">{nameError}</span>}
                    </div>
                  </div>
                  <div className="col-lg-6 service-img">
                    <div className="mil-input-frame mil-dark-input mil-tb">
                      <label className="mil-h6">
                        <span>Email Address</span>
                      </label>
                      <input type="text"
                        placeholder="Enter Your Email Address"
                        name="email"
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        value={formData.email}
                      />
                      {emailError && <span className="text-danger">{emailError}</span>}
                    </div>
                  </div>
                  <div className="col-lg-6  service-img">
                    <div className="mil-input-frame mil-dark-input mil-tb">
                      <label className="mil-h6 mil-dark">
                        <span>Define your Project or Message</span>
                      </label>
                      <input type="text"
                        placeholder="Enter Your Subject"
                        name="subject"
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        value={formData.subject}
                      />
                      {subjectError && <span className="text-danger">{subjectError}</span>}
                    </div>
                  </div>
                  <div className="col-lg-6 service-img">
                    <div className="mil-input-frame mil-dark-input mil-tb">
                      <label className="mil-h6">
                        <span>Details of your Project or Message</span>
                      </label>
                      <input type="text"
                        placeholder="Enter Your Message"
                        name="description"
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        value={formData.description}
                      />
                      {descriptionError && <span className="text-danger">{descriptionError}</span>}
                    </div>
                  </div>
                  <div className="col-lg-3 service-img" style={{marginTop:"25px"}}>
                    <button className="mil-button mil-border mil-fw" type="submit">
                      <span>Submit</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div className="col-lg-4 col-xl-4 ">
              <div className="mil-mb-60">
                <h2 className="mil-mb-30 mil-h2" style={{marginTop:"40px"}}>Got A Project Or Partnership In Mind?</h2>
                <p className="mil-mb-20 mil-dig-text" style={{ textAlign: 'justify' }}>
                  Connect with our team of IT experts today and discover how Aligned's Managed IT & Cybersecurity Services can not only secure and fuel the growth of your business but also trim costs, enabling your team to operate with heightened effectiveness. Begin the journey by filling out our form, and rest assured, we'll reach out to you promptly. Elevate your business security, streamline operations, and foster growth with Aligned – where innovation meets excellence, and success is not just a goal but a guarantee.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* map section*/}
      <div>
        <div className="mil-map-frame">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3669.534526144556!2d72.5388004748403!3d23.1141294129062!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e8332739793a7%3A0x78042d2966825297!2sPyther%20Innovations%20Private%20Limited!5e0!3m2!1sen!2sin!4v1690953263013!5m2!1sen!2sin!1z"
            width={600}
            height={450}
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Maps location for Pyther Innovations"
          />
        </div>
        <div className="container" />
      </div>
    </>
  )
}

export default Contact
